import React from "react";
import { Button, FormControl } from "react-bootstrap";
import { DisplayBox } from "../../components";
import { ApiHelper, ArrayHelper, PendingCommand, PlaylistMessageConditionInterface, PlaylistMessageInterface, QuestionInterface } from "../../helpers";


interface Props {
  playlistMessage: PlaylistMessageInterface
  sendCommand: (cmd: PendingCommand) => void
}


export const Conditions: React.FC<Props> = props => {

  const [playlistMessage, setPlaylistMessage] = React.useState<PlaylistMessageInterface>(null);
  const [questions, setQuestions] = React.useState<QuestionInterface[]>([]);

  const [questionId, setQuestionId] = React.useState(0);
  const [operator, setOperator] = React.useState("=");
  const [value, setValue] = React.useState("");
  const [dataType, setDataType] = React.useState("bool");


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "question": setQuestionId(parseInt(val, 0)); break;
      case "operator": setOperator(val); break;
      case "value": setValue(val); break;
      case "dataType": setDataType(val); break;
    }
  }



  const handleSave = () => {
    props.sendCommand({ action: "updateConditions", parameter: playlistMessage })
  }


  const init = () => {
    if (props.playlistMessage) {
      setPlaylistMessage(props.playlistMessage);
      let params = new URLSearchParams(window.location.search);
      ApiHelper.get("/questions/feed/" + params.get("feedId")).then(data => {
        setQuestions(data)
        if (data.length > 0) setQuestionId(data[0].id);
      });
    }
  }


  const loadConditions = async () => {
    if (playlistMessage && !playlistMessage.deleteConditionIds) {
      let conditions = [];
      if (playlistMessage.id > 0) {
        conditions = await ApiHelper.get("/playlistMessageConditions/playlistMessage/" + playlistMessage.id);
      }
      let pm = { ...playlistMessage };
      pm.conditions = conditions;
      pm.deleteConditionIds = [];
      setPlaylistMessage(pm);
    }
  }

  const handleDelete = (index: number) => {
    let pm = { ...playlistMessage };
    const conditions: PlaylistMessageConditionInterface[] = pm.conditions.splice(index, 1);
    if (conditions[0].id) pm.deleteConditionIds.push(conditions[0].id);
    setPlaylistMessage(pm);
  }

  React.useEffect(init, [props.playlistMessage]);  //eslint-disable-line
  React.useEffect(() => { loadConditions() }, [playlistMessage]);  //eslint-disable-line

  const getRows = () => {
    const result: JSX.Element[] = [];
    if (playlistMessage?.conditions) {
      let idx = 0;
      for (let c of playlistMessage?.conditions) {
        const q: QuestionInterface = ArrayHelper.getOne(questions, "id", c.questionId);
        if (q) {
          const index = idx;
          const deleteLink = <a href="about:blank" onClick={(e) => { e.preventDefault(); handleDelete(index) }}><i className="far fa-trash-alt text-danger"></i></a>
          result.push(<tr>
            <td>{q.title}</td>
            <td>{c.operator}</td>
            <td>{c.value}</td>
            <td>{c.dataType}</td>
            <td>{deleteLink}</td>
          </tr>)
        }
        idx++;
      }
    }
    return result;
  }

  const getDoneButton = () => {
    return <Button size="sm" variant="success" onClick={(e) => { e.preventDefault(); handleSave(); }}>Done</Button>
  }

  const getQuestions = () => {
    const result: JSX.Element[] = [];
    questions?.forEach(q => {
      result.push(<option value={q.id}>{q.title}</option>);
    })
    return result;
  }

  const handleAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    const pm = { ...playlistMessage };
    pm.conditions.push({ questionId, operator, value, dataType });
    setPlaylistMessage(pm);
  }


  return (
    <>
      <DisplayBox headerIcon="fas fa-equals" headerText="Conditions" editContent={getDoneButton()}  >
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Question</th>
              <th>Operator</th>
              <th>Value</th>
              <th>Type</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {getRows()}
            <tr>
              <td>
                <FormControl size="sm" as="select" id="question" value={questionId} onChange={handleChange}>
                  {getQuestions()}
                </FormControl>
              </td>
              <td>
                <FormControl size="sm" as="select" id="operator" value={operator} onChange={handleChange}>
                  <option value="=">=</option>
                  <option value="<">&lt;</option>
                  <option value="<=">&lt;=</option>
                  <option value=">=">&gt;=</option>
                  <option value=">">&gt;</option>
                  <option value="<>">&lt;&gt;</option>
                </FormControl>
              </td>
              <td>
                <FormControl size="sm" id="value" value={value} onChange={handleChange}></FormControl>
              </td>
              <td>
                <FormControl size="sm" as="select" id="dataType" value={dataType} onChange={handleChange}>
                  <option value="bool">True/False</option>
                  <option value="double">Number</option>
                  <option value="string">String</option>
                </FormControl>
              </td>
              <td>
                <Button size="sm" className="btn btn-success" onClick={handleAdd} >Add</Button>
              </td>
            </tr>
          </tbody>
        </table>
      </DisplayBox>
    </>
  );
};